const KEY = "std-saved";

export const getSavedStories = () => {
  try {
    const ids = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(ids) ? ids.filter((x) => typeof x === "string") : [];
  } catch {
    return [];
  }
};

export const isSaved = (id) => getSavedStories().includes(id);

export const toggleSavedStory = (id) => {
  const cur = getSavedStories();
  const next = cur.includes(id)
    ? cur.filter((x) => x !== id)
    : [id, ...cur].slice(0, 20);
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch (e) {}
  window.dispatchEvent(new CustomEvent("std-saved-changed"));
  return next;
};

export const removeSavedStory = (id) => {
  const next = getSavedStories().filter((x) => x !== id);
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch (e) {}
  window.dispatchEvent(new CustomEvent("std-saved-changed"));
  return next;
};
